import { Navigate, useLocation, useParams } from 'react-router-dom';
import CasesList from '../components/Selection/Cases/CasesList';
import CasesDetail from '../components/Selection/Cases/CaseDetail';
import CaseEdit from '../components/Selection/Cases/CaseEdit';
import ProjectsList from '../components/Selection/Projects/ProjectsList';
import {
    workspaceSelectionDeclarationAddPath,
    workspaceSelectionDeclarationEditPath,
    workspaceSelectionDeclarationsPath,
    workspaceSelectionReviewAssignPath,
    workspaceSelectionReviewCasesPath,
    workspaceSelectionReviewCasePath,
    workspaceSelectionReviewPersonnelPath,
    workspaceSelectionReviewRankingPath,
    workspaceSelectionReviewResetAssignPath,
    workspaceSelectionReviewScoringSettingsPath,
    workspaceSelectionReviewTopicsPath,
    workspaceSelectionReviewsPath,
    workspaceSelectionVotePath,
} from '../layouts/selectionWorkspacePaths';

function carryStateNavigateTarget(pathname, state) {
    return <Navigate to={pathname} replace state={state} />;
}

function LegacySelectionTopicsRedirect() {
    const { pid } = useParams();
    const location = useLocation();
    return carryStateNavigateTarget(workspaceSelectionDeclarationsPath(pid), location.state);
}

function LegacySelectionTopicAddRedirect() {
    const { pid } = useParams();
    const location = useLocation();
    return carryStateNavigateTarget(workspaceSelectionDeclarationAddPath(pid), location.state);
}

function LegacySelectionTopicEditRedirect() {
    const { pid, id } = useParams();
    const location = useLocation();
    return carryStateNavigateTarget(workspaceSelectionDeclarationEditPath(pid, id), location.state);
}

function LegacySelectionVoteTopicsRedirect() {
    const { pid } = useParams();
    const location = useLocation();
    return carryStateNavigateTarget(workspaceSelectionVotePath(pid), location.state);
}

function LegacySelectionReviewsRedirect() {
    const { pid } = useParams();
    const location = useLocation();
    return carryStateNavigateTarget(workspaceSelectionReviewsPath(pid), location.state);
}

function LegacySelectionReviewPersonnelRedirect() {
    const { pid, id } = useParams();
    const location = useLocation();
    return carryStateNavigateTarget(workspaceSelectionReviewPersonnelPath(pid, id), location.state);
}

function LegacySelectionReviewTopicsRedirect() {
    const { pid, id } = useParams();
    const location = useLocation();
    return carryStateNavigateTarget(workspaceSelectionReviewTopicsPath(pid, id), location.state);
}

function LegacySelectionReviewScoringRedirect() {
    const { pid, id, tid } = useParams();
    const location = useLocation();
    return carryStateNavigateTarget(workspaceSelectionReviewScoringSettingsPath(pid, id, tid), location.state);
}

function LegacySelectionReviewAssignRedirect() {
    const { pid, id } = useParams();
    const location = useLocation();
    return carryStateNavigateTarget(workspaceSelectionReviewAssignPath(pid, id), location.state);
}

function LegacySelectionReviewResetAssignRedirect() {
    const { pid, id } = useParams();
    const location = useLocation();
    return carryStateNavigateTarget(workspaceSelectionReviewResetAssignPath(pid, id), location.state);
}

function LegacySelectionReviewCasesRedirect() {
    const { pid, sid, tid } = useParams();
    const location = useLocation();
    return carryStateNavigateTarget(workspaceSelectionReviewCasesPath(pid, sid, tid), location.state);
}

function LegacySelectionReviewCaseRedirect() {
    const { pid, sid, tid, id } = useParams();
    const location = useLocation();
    return carryStateNavigateTarget(workspaceSelectionReviewCasePath(pid, sid, tid, id), location.state);
}

function LegacySelectionReviewRankingRedirect() {
    const { pid, sid, tid } = useParams();
    const location = useLocation();
    return carryStateNavigateTarget(workspaceSelectionReviewRankingPath(pid, sid, tid), location.state);
}

//医评议路由
const selectionRoutes = [
    //评议项目管理
    { path: '/selection/projects', element: <ProjectsList /> },
    //评议项目管理-新增
    { path: '/selection/projects/add', element: <Navigate to="/selection/projects/new" replace /> },
    //评议项目——主题
    { path: '/selection/projects/:pid/topics', element: <LegacySelectionTopicsRedirect /> },
    //评议项目管理-新增
    { path: '/selection/projects/:pid/topics/add', element: <LegacySelectionTopicAddRedirect /> },
    //评议项目——编辑
    { path: '/selection/projects/:pid/topics/:id', element: <LegacySelectionTopicEditRedirect /> },
    //评议项目-评分环节
    { path: '/selection/projects/:pid/score-stages', element: <LegacySelectionReviewsRedirect /> },
    //评议项目-评分环节-评委管理
    { path: '/selection/projects/:pid/score-stages/:id/personnel-management', element: <LegacySelectionReviewPersonnelRedirect /> },
    //评议项目-评分环节-主题管理
    { path: '/selection/projects/:pid/score-stages/:id/topics', element: <LegacySelectionReviewTopicsRedirect /> },
    //评议项目-评分环节-评分设置
    { path: '/selection/projects/:pid/score-stages/:id/scoring-settings/:tid', element: <LegacySelectionReviewScoringRedirect /> },
    //评议项目-评分环节-分配评委
    { path: '/selection/projects/:pid/score-stages/:id/assign', element: <LegacySelectionReviewAssignRedirect /> },
    //评议项目-评分环节-重置评委
    { path: '/selection/projects/:pid/score-stages/:id/reset-assign', element: <LegacySelectionReviewResetAssignRedirect /> },
    //评议项目-评分环节-主题管理-案例评分列表
    { path: '/selection/projects/:pid/score-stages/:sid/topics/:tid/cases', element: <LegacySelectionReviewCasesRedirect /> },
    //评议项目-评分环节-主题管理-案例评分列表-案例评分详情
    { path: '/selection/projects/:pid/score-stages/:sid/topics/:tid/cases', element: <LegacySelectionReviewCasesRedirect /> },
    //评议项目-评分环节-主题管理-案例评分列表-案例评分详情-评委评分详情
    { path: '/selection/projects/:pid/score-stages/:sid/topics/:tid/cases/:id', element: <LegacySelectionReviewCaseRedirect /> },
    //评议项目-评分环节-主题管理-案例评分列表-案例评分详情-评委评分详情-核对榜单
    { path: '/selection/projects/:pid/score-stages/:sid/topics/:tid/cases/list', element: <LegacySelectionReviewRankingRedirect /> },
    // 评议项目-投票管理
    { path: '/selection/projects/:pid/vote/topics', element: <LegacySelectionVoteTopicsRedirect /> },
    { path: '/selection/cases', element: <CasesList /> },
    { path: '/selection/cases/:id', element: <CasesDetail /> },
    { path: '/selection/cases/edit/:id', element: <CaseEdit /> },
];
export default selectionRoutes;
